// watch/embedCode.ts — the <iframe> snippet ⋯ Embed video hands out (1.27.60).

function escapeAttr(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}

export function embedCode(postId: string, title: string, startSec?: number): string {
  const src = `${window.location.origin}/embed/videos/${encodeURIComponent(postId)}${
    startSec ? `?t=${Math.floor(startSec)}` : ''
  }`;
  return (
    `<iframe width="560" height="315" src="${src}" title="${escapeAttr(title)}" ` +
    `frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`
  );
}
